/** @jsx jsx */
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const accordion = css`
  font-weight: 400;
  overflow: hidden;
  border: none;
  .card__header {
    background: none;
  }
  .card {
    background: inherit;
    border: none;
    &__header {
      padding: 0;
    }

    &__body {
      color: #212529;
      display: flex;
      flex-direction: column;
      font-size: 14px;
      font-family: 'Open Sans';
      font-weight: 400 !important;
      line-height: 150%;
      margin-top: 0px;
      padding: 0px;
      @media (max-width: 768px) {
        font-size: 16px;
        line-height: 150%;
      }
    }
  }
  .card-header {
    border-bottom: none;
  }
  ul {
    padding-inline-start: 0px;
  }
  li{
    color: #312E2D;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;  
    padding-bottom: 10px;
  }
  .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 0px;
}
`

export const Button = styled.button`
  border: none;
  background: transparent;
  color: #00854E;
  text-align: left;
  padding: 0;
  margin-bottom: ${(props) => (props.isShowing ? '14.5px' : '0px')};
  width: 100%;

  .title {
    align-items: baseline;
    display: flex;
    gap: 20px;
    margin-top: 8px;
    padding: 0px 0px 0px 0px;
    justify-content: flex-start;
    @media (max-width: 500px) {
      margin-bottom: 0;
    }
    h5 {
      margin-top: 34px;
      color: #0c79fe;
      font-size: 16px;
      font-weight: 700;
      @media (max-width: 500px) {
        font-size: 12px;
        line-height: 14.4px;
        font-weight: 600;
        margin-top: 15px;
      }
    }
    h3 {
        color:  #00854E;
        font-variation-settings: "wght" 130, "wght" 600;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 120%;  
        margin-top: 0px; 
        margin-bottom: 0px;
      @media (max-width: 500px) {
        font-size: 16px;
        line-height: 24px;
      }
    }

    span {
      align-items: center;
      transform: ${(props) =>
        props.isShowing ? 'rotate(180deg)' : 'rotate(0deg)'};
      transition: all 0.3s ease-out;
      display: flex;
      justify-content: center;
      height: 2em;
      width: 2em;
      padding: 0.25em;
      border-radius: 50%;
      &:hover {
        .icon {
          color: #0c79fe;
          transition: color 0.3s ease-out;
        }
      }
    }
  }

  .text {
    color: #fff;
    display: ${(props) => (props.isShowing ? 'none' : 'initial')};
    font-weight: 400 !important;

    p {
      color: #fff;
      line-height: 150%;
      margin: 0;
    }
  }
`

export const hrStyle = css`
  border-bottom: 0px solid #000000;
  margin: 0;
  border-top: 0px solid rgba(0, 0, 0, 0.1);
`